var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopifyLogoMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17.001,
    viewBox: "0 0 15 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.1 0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.223,3.268a.16.16,0,0,0-.151-.137C13,3.131,11.8,3.1,11.8,3.1s-1.014-.986-1.11-1.082a.406.406,0,0,0-.37-.041s-.192.055-.507.151a4.009,4.009,0,0,0-.247-.6A1.717,1.717,0,0,0,8.045.474h0a.514.514,0,0,0-.137.014C7.895.46,7.867.446,7.853.419A1.3,1.3,0,0,0,6.8-.006,3.04,3.04,0,0,0,4.5,1.665a6.792,6.792,0,0,0-.932,2.4c-.945.288-1.6.493-1.616.507-.479.151-.493.164-.548.616-.041.342-1.3,10-1.3,10l10.466,1.808L15.1,15.871C15.086,15.857,13.237,3.35,13.223,3.268ZM9.292,2.3c-.247.068-.521.164-.808.247a4.362,4.362,0,0,0-.247-1.493C8.853,1.172,9.155,1.871,9.292,2.3Zm-1.37.425c-.548.164-1.151.356-1.753.534a4.232,4.232,0,0,1,.877-1.712A2.2,2.2,0,0,1,7.634,1.1,3.585,3.585,0,0,1,7.922,2.72ZM6.812.542a.941.941,0,0,1,.493.123,2.681,2.681,0,0,0-.644.507A4.891,4.891,0,0,0,5.579,3.446l-1.438.438C4.429,2.569,5.538.583,6.812.542Z",
    transform: "translate(0 0)",
    fill: "#95bf47"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.867 1.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.921,15.478c-.068,0-1.274-.027-1.274-.027s-1.014-.986-1.11-1.082A.261.261,0,0,0,76.4,14.3V29.327L80.934,28.2S79.085,15.7,79.071,15.6A.161.161,0,0,0,78.921,15.478Z",
    transform: "translate(-68.715 -14.3)",
    fill: "#5e8e3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.464,38.785l-.521,1.973a2.859,2.859,0,0,0-1.288-.219c-1.027.068-1.027.712-1.027.877.055.877,2.37,1.068,2.507,3.137a2.437,2.437,0,0,1-2.247,2.822A3.361,3.361,0,0,1,20.3,46.5l.356-1.507a3.111,3.111,0,0,0,1.658.644.662.662,0,0,0,.644-.7c-.068-1.151-1.959-1.082-2.082-2.973a3.144,3.144,0,0,1,3.247-3.342A2.7,2.7,0,0,1,25.464,38.785Z",
    transform: "translate(-20.3 -35.278)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyLogoMark);
export default __webpack_public_path__ + "static/media/Shopify_LogoMark.7950145f524f6e6dd773e47926520952.svg";
export { ForwardRef as ReactComponent };